import React from "react";

const Footer = () => (
  <footer>
    <p>Created by Ilze Spruge <span>&#128522;</span></p>
  </footer>
);

export default Footer;